module.exports = __webpack_public_path__ + "static/media/img-devteam-page-mobile@3x.6cfa9796.png";